

import { createContext } from 'react';


const dataAdapter = createContext({});
const { Provider } = dataAdapter;

export {
  dataAdapter,
  Provider as DataAdapterProvider };